// extracted by mini-css-extract-plugin
export var gif = "_lj-0";